import { useState } from "react";
import { Card, CardBody } from "react-bootstrap";
import { Navigate, NavLink, Route, Routes } from "react-router-dom";

import { PageTitle } from "../../components/PageTitle";
import { useOrganizationContext } from "../../contexts/organizations/organizationsContext";
import { formatNumber } from "../../utils/NumbersFormatting";
import { InvitationsPage } from "./components/InvitationsPage/InvitationsPage";
import { MembersPage } from "./components/MembersPage/MembersPage";
import { InviteMembersModal } from "./components/modals/InviteMemebersModal/InviteMembersModal";

const settingsBreadcrumbs = [
  {
    title: "Organization",
    path: "",
    isSeparator: false,
    isActive: true,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const MembersWrapper = () => {
  const [membersAmount, setMembersAmount] = useState<number>(0);

  const { currentOrganization } = useOrganizationContext();

  return (
    <>
      {currentOrganization && (
        <div className="manage-cache-item-page d-flex flex-column h-100">
          <div className="d-flex justify-content-between align-items-center ">
            <PageTitle
              breadcrumbs={settingsBreadcrumbs}
              breadcrumbTitle="Members"
              pageTitle={`Members ${
                membersAmount ? `(${formatNumber(membersAmount)})` : ""
              }`}
            />
            <InviteMembersModal />
          </div>
          <div className="manage-cache-item-page__nav d-flex align-items-center justify-content-start">
            <NavLink to="/organization/members/all">All members</NavLink>
            <NavLink to="/organization/members/invitations">
              Invitations
            </NavLink>
          </div>
          <Card>
            <CardBody className="d-flex flex-column">
              <Routes>
                <Route
                  path="/all"
                  element={
                    <MembersPage
                      setMembersAmount={setMembersAmount}
                      currentOrganizationId={currentOrganization?.id || ""}
                      orgOwnerId={currentOrganization?.owner?.id || ""}
                    />
                  }
                />
                <Route
                  path="/invitations"
                  element={
                    <InvitationsPage
                      currentOrganizationId={currentOrganization.id || ""}
                    />
                  }
                />
                <Route
                  index
                  element={<Navigate to="/organization/members/all" />}
                />
              </Routes>
            </CardBody>
          </Card>
        </div>
      )}
    </>
  );
};

export { MembersWrapper };
